
<script setup>

  import { ref, watch } from 'vue';

  const props = defineProps( {
    
    index: Number, paper: Number,

    front: String, back: String,

    flip: Boolean,
  
  } );

  const angle = ref( 0 );

  const zIndex = ref( 1 );

  let frame = null;

  watch( () => props.flip, flip => {

    cancelAnimationFrame( frame );

    let start = null;

    const to = flip ? -180 : 0;
    
    const from = angle.value;

    const distance = Math.abs( to - from );

    const direction = Math.sign( to - from );

    function step( now ) {

      if ( ! start ) start = now;

      const progress = Math.min( Math.max( ( now - start ) / 1000, 0 ), 1 );

      angle.value = Math.round( from + distance * direction * progress );

      if ( progress < 1 ) frame = requestAnimationFrame( step );

      else angle.value = to;

    }

    if ( from !== to ) frame = requestAnimationFrame( step );

  } );

  watch( () => [ props.index, props.paper, angle.value ], ( [ index, paper, angle ] ) => {

    zIndex.value = angle <= -90 ? index - paper : paper - index

  }, { immediate: true } );

</script>

<template>

  <div class="absolute right-0 w-1/2 h-full select-none"
  
    :style="{ transformStyle: 'preserve-3d', transformOrigin: '0 0', transform: `rotateY( ${ angle }deg )`, zIndex }">

    <img :src="front" alt="" class="absolute w-full h-full" style="transform: rotateY( 0deg ) translateZ( 1px )" draggable="false" />

    <img :src="back" alt="" class="absolute w-full h-full" style="transform: rotateY( 180deg ) translateZ( 1px )" draggable="false" />

  </div>

</template>
